import { render } from "./bookmarkCategoryListItem.vue?vue&type=template&id=474afe8e&scoped=true"
import script from "./bookmarkCategoryListItem.vue?vue&type=script&lang=js"
export * from "./bookmarkCategoryListItem.vue?vue&type=script&lang=js"

import "./bookmarkCategoryListItem.vue?vue&type=style&index=0&id=474afe8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-474afe8e"

export default script